import { useMemo } from 'react';
import { getConfigAmbiente, getEscopoComponentes } from '../../../services/authentication/auth';

export const CHAVE_SERVICO_CHAT_IA = 'CHAT_IA';
export const CHAVE_COMPONENTE_CHAT_IA = 'chat-ia';
export const MODULO_CHAT_IA = 'plataforma_oneshell';

/**
 * Duas condicoes independentes decidem se o chat aparece, as mesmas que o
 * backend aplica no middleware chat.acesso:
 *
 *   1. o servico esta habilitado no tenant  -> escopo-ambiente.servicos.CHAT_IA
 *   2. o usuario tem a permissao da tela    -> escopo-usuario, tela componente/chat-ia
 *
 * O backend e a fonte da verdade (devolve 403); aqui so evitamos mostrar um
 * botao que nao funcionaria.
 */
const useChatIaDisponivel = escopoAcesso =>
  useMemo(() => {
    const servicos = getConfigAmbiente()?.servicos ?? {};

    // Comparacao com `false` explicito, e nao negacao simples: o escopo-ambiente
    // fica no localStorage com validade de um dia (carregarEscopoAmbienteTenant),
    // entao a AUSENCIA da chave significa cache anterior ao deploy do backend --
    // nao "desabilitado". Negar nesse caso apagaria o chat de todo mundo ate a
    // data virar.
    if (servicos[CHAVE_SERVICO_CHAT_IA] === false) {
      return false;
    }

    // Fallback no sessionStorage porque ha telas que renderizam <Main> sem a prop
    // escopoAcesso.
    const escopo = escopoAcesso || getEscopoComponentes() || {};

    // Optional chaining tambem antes do bracket: formatarEscopo so cria a chave
    // `componente` quando existe ao menos uma tela desse tipo no escopo, entao
    // acessar o indice direto lanca TypeError para quem nao tem nenhuma.
    return Boolean(escopo?.[MODULO_CHAT_IA]?.componente?.[CHAVE_COMPONENTE_CHAT_IA]);
  }, [escopoAcesso]);

export default useChatIaDisponivel;
